export default __webpack_public_path__ + "static/cafe_36090-86d73707ca9a82ec944288a4bec2b3ba.png";